import {useState} from "react";

export const useCollectionView = (storageKey, defaultView = "list") => {
    const [view, setView] = useState(() => {
        try {
            const stored = localStorage.getItem(storageKey);
            return stored === "list" || stored === "cards" ? stored : defaultView;
        } catch {
            return defaultView;
        }
    });

    const changeView = (next) => {
        setView(next);
        try {
            localStorage.setItem(storageKey, next);
        } catch {
            // View preferences are optional when browser storage is unavailable.
        }
    };

    return [view, changeView];
};
